export default __webpack_public_path__ + "static/media/userCheckTrue.2154b763.svg";